define(function() {
    const IpsModelCollection = require('civicsBase/ipsModelCollection');
    const utils = require('civicsUtils/general_utilities');
    const ViewManager = require('civicsUtils/view_manager');

    return IpsModelCollection.extend({
        urlRoot: '/delegate/civics-api/api/',
        completed: function() {
            var filtered = this.filter(function(model) {
                return model.get('completed') === true;
            });
            return new IpsModelCollection(filtered);
        },
        url: function() {
          return this.urlRoot + 'cdr/applications/' + this.instrumentType + '/' + this.id + '/inspections?Page=[{Max:0}]&Select=[id,Application,AssignedToProvider.Identity.FirstName,AssignedToProvider.Identity.LastName,AssignedToProvider.id,CallDateTime,CompletedDateTime,ContactInfo,ContactPerson,InspectionType.Id,InspectionType.Description,InspectionType.PortalDescription,InspectionTypeNumber,IsPartial,Location,RequestedBy.MembershipKey,Result,ResultDateTime,ResultDescription,ScheduledDateTime,ServiceProviders,SpecialInstructions,StartDateTime,TimePreference,TimePreferenceDescription,Type]';
        },
        parse: function(response) {
            var data = response.data;
            for (var i = 0; i < data.length; i++) {
                if (data[i].result && data[i].result.trim().length > 0 ) {
                    data[i].completed = true;
                } else {
                    data[i].completed = false;
                }
            }

            return data;
        },
    });
});
